import { forwardRef, useContext } from 'react';

import { StepContext } from '@mui/material/Step';
import MuiStepLabel, { StepLabelProps as MuiStepLabelProps } from '@mui/material/StepLabel';

import Link, { LinkProps } from '../Link';
import StepIcon from '../StepIcon';

export * from '@mui/material/StepLabel';

export interface StepLabelProps extends Omit<MuiStepLabelProps, 'error'> {
  /**
   * Props applied to the Link component, if this StepLabel is in a completed Step.
   */
  linkProps?: LinkProps;
}

const StepLabel = forwardRef<HTMLSpanElement, StepLabelProps>(({ children, ...props }, ref) => {
  const stepContextValue = useContext(StepContext);

  return (
    <MuiStepLabel StepIconComponent={StepIcon} {...props} ref={ref}>
      {'completed' in stepContextValue && stepContextValue.completed ? <Link inverted>{children}</Link> : children}
    </MuiStepLabel>
  );
});

StepLabel.displayName = 'StepLabel';

export default StepLabel;
